import angular from 'angular';
import _ from 'lodash';

(function () {
    'use strict';
    angular.module('app.core').factory('InvoiceTemplateDA', InvoiceTemplateDA);

    InvoiceTemplateDA.$inject = [
        '$q',
        'logger',
        'Restangular',
        'Upload',
        'CONF',
        'InvoiceTemplate',
        'InvoiceTemplateInfo',
        'ControlSet',
        'PrincipalControlSet'
    ];

    /**
     * Class permettant al manipulation des template de facture
     */

    /* @ngInject */
    function InvoiceTemplateDA(
        $q,
        logger,
        Restangular,
        Upload,
        CONF,
        InvoiceTemplate,
        InvoiceTemplateInfo,
        ControlSet,
        PrincipalControlSet
    ) {
        var baseUrl = CONF.apiBaseUrl + '/v1/template-invoices';
        var fullBaseUrl = CONF.apiContext + CONF.apiBaseUrl + '/v1/template-invoices';

        var exports = {
            getFullTemplate: getFullTemplate,
            getInvoiceTemplate: getInvoiceTemplate,
            saveInvoiceTemplate: saveInvoiceTemplate,
            getControlSets: getControlSets,
            getPrincipalControlSets: getPrincipalControlSets,
            stageLegible: stageLegible,
            getLegibleFileId: getLegibleFileId
        };

        return exports;

        ////////////////

        /**
         * Récupère tous les attributs du model étendu pour un donneur d'ordre désigné
         * ce ne sont pas uniquement les attributs qui vont apparaitre à l'écran,
         * mais ceux à l'écran + ceux qui pourront être rajoutés pour ce DO
         *
         * @param {string} principalEid - Identifiant (EID) du DO
         * @returns InvoiceTemplate comportant la liste des attributs du model étendu
         *
         */
        function getFullTemplate(principalEid) {
            return Restangular.one(baseUrl, principalEid)
                .oneUrl('all')
                .get()
                .then(function (data) {
                    return new InvoiceTemplate(data).attributes;
                });
        }

        /**
         * Récupère les attributs du model à afficher pour le spécifique
         *
         * @param {string} principalEid - Identifiant du DO
         * @returns InvoiceTemplate comportant la liste des attributs du model spécifique
         */
        function getInvoiceTemplate(principalEid) {
            return Restangular.one(baseUrl, principalEid)
                .oneUrl('edit')
                .get()
                .then(function (data) {
                    return new InvoiceTemplateInfo(data);
                });
        }

        /**
         * Enregistrement du model spécifique
         *
         * @param {string} principalEid - Identifiant (EID) du DO
         * @param {invoiceTemplateParams} invoiceTemplateParams - Donnée de la facture à enregistrer
         */
        function saveInvoiceTemplate(principalEid, invoiceTemplateParams) {
            return Restangular.one(baseUrl, principalEid)
                .all('update')
                .post(invoiceTemplateParams)
                .then(function (data) {
                    return _.map(data, function (data) {
                        return new InvoiceTemplate(data);
                    });
                });
        }

        /**
         * Récupère les set de controles.
         */
        function getControlSets(principalEid) {
            return Restangular.one(baseUrl, principalEid)
                .oneUrl('controlsets')
                .get()
                .then(function (data) {
                    return _.map(data.controlSets, function (controlSet) {
                        return new ControlSet(controlSet);
                    });
                });
        }

         /**
         * Récupère les set de controles spécifiques au DO.
         */
         function getPrincipalControlSets(principalEid, dictionaryKeys) {
            return Restangular.one(baseUrl, principalEid)
                .all('principalspecificontrolsets')
                .post(dictionaryKeys)
                .then(function (data) {
                    return _.map(data.principalControlSets, function (controlSet) {
                        return new PrincipalControlSet(controlSet);
                    });
                });
        }

        function stageLegible(principalEid, legibleFile) {
            return Upload.upload({
                url: fullBaseUrl + '/' + principalEid + '/stage-legible',
                data: {
                    file: legibleFile
                }
            });
        }

        function getLegibleFileId(principalEid) {
            return Restangular.one(baseUrl, principalEid)
                .oneUrl('legible')
                .get()
                .then(function (legibleId) {
                    return legibleId;
                });
        }
    }
})();
